import React, { useMemo } from 'react';
import { Select } from 'antd';
import { useSystemClassifierSelectOptions } from '../configuration/useSystemClassifierSelectOptions';
import styled from 'styled-components';
import { useFormContext, useWatch } from 'react-hook-form';
import { DataObjectFormDataType } from './types';

export const DataObjectStatusSelect = () => {
  const form = useFormContext<DataObjectFormDataType>();
  const statusCode = useWatch({ name: 'statusCode' });

  const systemClassifiers = useSystemClassifierSelectOptions(
    ['DATA_OBJ_GRP_VER_STATUS'],
    'code'
  );

  const allowedStates = useMemo(
    () => getAllowedStatusCodes(statusCode),
    [statusCode]
  );

  const statusOptions = useMemo(
    () =>
      systemClassifiers.DATA_OBJ_GRP_VER_STATUS.filter((item) =>
        allowedStates.includes(item.value as string)
      ),
    [systemClassifiers, allowedStates]
  );

  const handleChange = (value: string) => {
    form.setValue('statusCode', value, { shouldDirty: true });
  };

  return (
    <SelectWrapper
      id="statusCode-select"
      value={statusCode}
      styles={{
        popup: { root: { width: 'max-content' } },
      }}
      onChange={handleChange}
      options={statusOptions}
    />
  );
};

const getAllowedStatusCodes = (statusCode?: string) => {
  switch (statusCode) {
    case 'ACTIVE':
    case 'INACTIVE':
      return ['ACTIVE', 'DRAFT', 'INACTIVE'];
    case 'DRAFT':
    default:
      return ['ACTIVE', 'DRAFT'];
  }
};

const SelectWrapper = styled(Select<any, any>)`
  width: 100px;
`;
